<script setup lang="ts">
import type { ModuleStats, Response } from '@/models/api-generated'
import {
	ConditionallyImplemented,
	Implemented,
	NeedsAttention,
	NotImplemented,
	PartiallyImplemented,
	WillNotApply,
	WillNotImplement,
	type MethodStatus,
} from '@/models/enums-generated'
import http from '@/services/http'
import { onBeforeMount, ref } from 'vue'

const props = defineProps<{
	moduleMetaId: number
}>()

const stats = ref<ModuleStats>()

onBeforeMount(async () => {
	const { data } = await http.get<Response<ModuleStats>>(`api/module/stats/${props.moduleMetaId}`)
	if (data.data) stats.value = data.data
})

function calc(status: MethodStatus) {
	if (!stats.value) return

	const num = stats.value.methodStatuses[status] ?? 0
	const total = stats.value.total === 0 ? 1 : stats.value.total
	return ((num * 100) / total).toFixed(0) + '%'
}
</script>

<template>
	<div v-show="stats" class="text-nowrap">
		<span v-one-tooltip="$t('status.implemented')"><i class="bi bi-square-fill me-2 ms-2 pie1"></i>{{ calc(Implemented) }}</span>
		<span v-one-tooltip="$t('status.conditionallyImplemented')">
			<i class="bi bi-justify me-2 ms-2 pie1"></i>{{ calc(ConditionallyImplemented) }}
		</span>
		<span v-one-tooltip="$t('status.partiallyImplemented')">
			<i class="bi bi-square-fill me-2 ms-2 pie2"></i>{{ calc(PartiallyImplemented) }}
		</span>
		<span v-one-tooltip="$t('status.notImplemented')"><i class="bi bi-square-fill me-2 ms-2 pie3"></i>{{ calc(NotImplemented) }}</span>
		<span v-one-tooltip="$t('status.willNotApply')"><i class="bi bi-square-fill me-2 ms-2 pie4"></i>{{ calc(WillNotApply) }}</span>
		<span v-one-tooltip="$t('status.willNotImplement')"><i class="bi bi-justify me-2 ms-2 pie4"></i>{{ calc(WillNotImplement) }}</span>
		<span v-one-tooltip="$t('status.needsAttention')"><i class="bi bi-square-fill me-2 ms-2 pie6"></i>{{ calc(NeedsAttention) }}</span>
	</div>
</template>

<style lang="sass" scoped>
span
  display: inline-block
  width: 4.5rem
</style>
